import GenericPage from '../page-generic';
import image from '../../assets/HiWrenchScrewdriver.svg';

export default function MaintenancePage() {
	return (
		<GenericPage title={'Kiosk in Maintenance Mode'} message={'We apologize for the inconvenience.'} imageSrc={image} imageAlt={'Maintenance'} />
	);
}
